<template>
  <h1>You Just Registered!</h1>
</template>
<script>
//insert rest of the registration landing page info/ guides/ check email prompt etc.
</script>
